import React, { HTMLAttributes, ReactElement } from 'react'
import ReactDOM from 'react-dom'

import isMounted from '../../utils/hooks/useIsMounted'

export default function Portal(props: HTMLAttributes<HTMLDivElement>): ReactElement | null {
  return isMounted() ? ReactDOM.createPortal(<div {...props} />, document.querySelector('.body')) : null
}
